<template>
  <div class="row p-1 d-flex align-items-center">
    <div class="col" v-if="!props.sold_to">
      <button
        class="btn btn-sm btn-success tinytxt"
        v-if="!props.bidding_open"
        @click="toggleBidding(true)"
      >
        Open bids
      </button>
      <button
        class="btn btn-sm btn-danger tinytxt"
        v-else
        @click="toggleBidding(false)"
      >
        Close bids
      </button>
    </div>
    <div class="col" v-if="!props.sold_to">
      <button
        class="btn btn-sm btn-danger tinytxt"
        v-if="!props.halt_bidding"
        @click="haltBidding(true)"
      >
        Halt bids!
      </button>
      <button
        class="btn btn-sm btn-success tinytxt"
        v-else
        @click="haltBidding(false)"
      >
        Start bids
      </button>
    </div>
    <div class="col">
      <button
        class="btn btn-sm btn-secondary tinytxt"
        @click="previousPlayer()"
      >
        <i class="bi bi-caret-left"></i>
      </button>
    </div>
    <div class="col">
      <button class="btn btn-sm btn-primary tinytxt" @click="nextPlayer()">
        <i class="bi bi-caret-right"></i>
      </button>
    </div>
  </div>
</template>
<script setup>
import {
  onBeforeMount,
  onMounted,
  defineProps,
  ref,
  computed,
  watchEffect,
} from "vue";
import { useStore } from "@/store/index";
import supabase from "@/supabase/config";
const pool_list = ref([]);
const active_pool = ref("");
const store = useStore();
const props = defineProps([
  "player_id",
  "bidding_open",
  "halt_bidding",
  "sold_to",
]);
const toggleBidding = async (bool) => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ bidding_open: bool })
    .eq("id", store.live_auction)
    .select();
  if (bool) {
    haltBidding(false);
  }
};
const haltBidding = async (bool) => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ halt_bidding: bool })
    .eq("id", store.live_auction)
    .select();
};
watchEffect(() => {
  if (store.sale_action == "sale-done-show-next-player") {
    store.saleAction("");
    //console.log("triggering next player...");
    nextPlayer();
  }
  if (store.sale_action == "sale-done-clear-live-player") {
    store.saleAction("");
    clearExistingLivePlayer(); //if running in player selection mode then next players is NOT triggered
  }
});
onBeforeMount(() => {
  fetchActivePool();
});
onMounted(() => {
  setTimeout(() => {
    preparePoolList();
  }, 500);
});
const fetchActivePool = async () => {
  let { data: pool_list, error } = await supabase
    .from("pool_list")
    .select("*")
    .eq("player_id", props.player_id);
  active_pool.value = pool_list[0].pool_id;
};
const preparePoolList = async () => {
  let { data: pool_list_, error } = await supabase
    .from("pool_list")
    .select("*")
    .eq("pool_id", active_pool.value)
    .order("sort", { ascending: true });
  pool_list.value = pool_list_;
};
const nextPlayer = () => {
  const present_index = pool_list.value.findIndex(
    (obj) => obj.player_id === props.player_id
  );
  const next_index = getNextIndex(present_index, pool_list.value.length);
  const next_player_id = pool_list.value[next_index].player_id;
  setAsLivePlayer(next_player_id);
};
const previousPlayer = () => {
  const present_index = pool_list.value.findIndex(
    (obj) => obj.player_id === props.player_id
  );
  const previous_index = getPreviousIndex(
    present_index,
    pool_list.value.length
  );
  const previous_player_id = pool_list.value[previous_index].player_id;
  setAsLivePlayer(previous_player_id);
};

function getNextIndex(currentIndex, arrayLength) {
  return (currentIndex + 1) % arrayLength;
}
function getPreviousIndex(currentIndex, arrayLength) {
  return (currentIndex - 1 + arrayLength) % arrayLength;
}
const setAsLivePlayer = async (id) => {
  clearExistingLivePlayer(); //this is done to trigger a reload of the LivePlayer component
  setTimeout(() => {
    setLivePlayer(id);
  }, 200);
  setBiddingOpenToFalse();
};
const clearExistingLivePlayer = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ live_player_id: null })
    .eq("id", store.live_auction)
    .select();
};
const setLivePlayer = async (id) => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ live_player_id: id })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    updatePlayerIDinPoolTable(id);
  }
};
const updatePlayerIDinPoolTable = async (id) => {
  const { data, error } = await supabase
    .from("pools")
    .update({ live_player_pointer: id })
    .eq("id", active_pool.value)
    .select();
};
const setBiddingOpenToFalse = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ bidding_open: false })
    .eq("id", store.live_auction)
    .select();
};
</script>
<style scoped>
.tinytxt {
  font-size: 10px;
  padding: 2px;
}
</style>
